module.exports = __webpack_public_path__ + "static/media/Portrait-10019.211ee360.jpg";